import React, { useState, useEffect } from 'react'
import { Select } from "antd";
import { getAutonomousCommunityProvinces, MapAutonomousCommunity, MapProvince } from '../../../services/map-municipalities.service';
import { ADD_ALL_ID } from './MapMunicipalitySearchForm';
import { SelectValue } from 'antd/lib/select';
import styled from 'styled-components';

type MapProvinceSelectProps = {
  selectedAutonomousCommunities: MapAutonomousCommunity[],
  lastSelectedAutonomousCommunity?: MapAutonomousCommunity,
  selectedProvinces: MapProvince[],
  lastSelectedProvince?: MapProvince,
  handleAutonomousCommunitySelection: (autonomousCommunity: MapAutonomousCommunity) => void,
  handleSelection: (province: MapProvince) => void
  disabled: boolean
}

export const MapProvinceSelect: React.FC<MapProvinceSelectProps> = ({
  selectedProvinces,
  lastSelectedProvince,
  selectedAutonomousCommunities,
  lastSelectedAutonomousCommunity,
  handleAutonomousCommunitySelection,
  handleSelection,
  disabled
}) => {
  const [provinces, setProvinces] = useState<MapProvince[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (!lastSelectedAutonomousCommunity) {
      setProvinces([]);
      return;
    }

    const controller = new AbortController();
    setLoading(true);

    getAutonomousCommunityProvinces(lastSelectedAutonomousCommunity, controller.signal).then(data => {
      if (data) {
        const extendedData = [{ id: ADD_ALL_ID, autonomousCommunity: lastSelectedAutonomousCommunity, name: "Toda la comunidad autónoma", separated: true }, ...data];
        setProvinces(extendedData);
      }
    }).catch(err => {
      if (err.name !== 'AbortError') {
        console.error('Error fetching provinces:', err);
      }
    }).finally(() => setLoading(false));

    return () => controller.abort();
  }, [lastSelectedAutonomousCommunity]);

  const { Option } = Select

  const onChange = (value: SelectValue) => {
    if (selectedProvinces.some(it => it.id === value)) {
      return;
    }
    const province = provinces.find(it => it.id === value)
    if (!province)
      return;

    if (province.id === ADD_ALL_ID) {
      handleAutonomousCommunitySelection(lastSelectedAutonomousCommunity!)
    } else {
      handleSelection(province)
    }

  }

  const allProvincesOptionSelected = selectedAutonomousCommunities.some(it => it.id === lastSelectedAutonomousCommunity?.id);

  return <SearchBar
    size="large"
    showSearch
    placeholder="Provincia"
    optionFilterProp="children"
    onChange={onChange}
    loading={loading}
    value={allProvincesOptionSelected ? provinces[0]?.id : lastSelectedProvince?.id}
    disabled={!lastSelectedAutonomousCommunity || disabled}>
    {provinces.map((se: any) => (
      <Option key={se.id} value={se.id} disabled={selectedProvinces.some(it => it.id === se.id) || allProvincesOptionSelected}>
        {se.name}
      </Option>
    ))}
  </SearchBar>
}

const SearchBar = styled(Select)`
  width: 100%;
`